// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_f3-0";